<template>
    <aside class="navbar navbar-vertical navbar-expand-lg" data-bs-theme="dark">
        <div class="container-fluid">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#sidebar-menu" aria-controls="sidebar-menu" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="navbar-brand navbar-brand-autodark">
                <router-link :to="{ 'name': 'home' }">
                    <span v-html="require('@/assets/img/logo-white.svg').default" class="navbar-brand-image" />
                </router-link>
            </div>
            <div class="navbar-nav flex-row d-lg-none">
                <div class="nav-item dropdown">
                    <a href="#" class="nav-link d-flex lh-1 text-reset p-0" data-bs-toggle="dropdown" aria-label="Open user menu">
                        <span class="avatar avatar-sm">
                            {{ userInitials }}
                        </span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <router-link :to="{ 'name': 'profile' }" class="dropdown-item">
                            <span>{{userName}}</span>
                        </router-link>
                        <router-link :to="{ 'name': 'credits' }" class="dropdown-item">
                            <span>
                                <span class="nav-link-icon d-lg-inline-block">
                                    <icon icon="coin" height="1.25em" />
                                </span>
                                <span>
                                    {{ creditMinutes }}
                                    <span class="mt-1 small text-secondary">minutes</span>
                                </span>
                            </span>
                        </router-link>
                        <div class="dropdown-divider"></div>
                        <span>
                            <router-link v-for="(item, i) in userMenu" :key="i" class="dropdown-item" :class="{ 'active': item.route === $route.name }" :to="{ 'name': item.route }">
                                <span class="nav-link-icon d-lg-inline-block" v-show="item.icon">
                                    <icon :icon="item.icon" height="1.25em" />
                                </span>
                                <span class="nav-link-title">{{ item.title }}</span>
                            </router-link>
                        </span>
                    </div>
                </div>
            </div>
            <div class="collapse navbar-collapse" id="sidebar-menu">
                <ul class="navbar-nav pt-lg-3">

                    <li class="nav-item" v-for="(item, i) in menu" :key="i" :class="{ 'active': item.route === $route.name, 'dropdown': item.children }">
                        <router-link :to="{ 'name': item.route }" class="nav-link" :class="{ 'active': item.route === $route.name, 'dropdown-toggle': item.children }" v-bind="{'data-bs-toggle': item.children ? 'dropdown' : null, 'data-bs-auto-close': item.children ? 'outside' : null}" role="button" aria-expanded="false">
                            <span class="nav-link-icon d-lg-inline-block">
                                <icon :icon="item.icon" height="1.25em" />
                            </span>
                            <span class="nav-link-title">{{ item.title }}</span>
                        </router-link>
                        <div v-show="item.children" class="dropdown-menu">
                            <router-link v-for="(child, j) in item.children" :key="j" :to="{ 'name': child.route }" class="dropdown-item">
                                {{ child.title }}
                            </router-link>
                        </div>
                    </li>

                    <li class="nav-link nav-link-separator d-block d-md-none mt-3">
                        <a v-show="theme && theme.theme == 'dark'" @click.prevent="setTheme('light')"  data-bs-toggle="tooltip" data-bs-placement="bottom" aria-label="Enable light mode" data-bs-original-title="Enable light mode">
                            <span class="nav-link-icon d-lg-inline-block">
                                <icon icon="theme-light" height="1.25em" />
                            </span>
                            <span class="nav-link-title">Light mode</span>
                        </a>
                        <a v-show="!(theme && theme.theme == 'dark')"  @click.prevent="setTheme('dark')" data-bs-toggle="tooltip" data-bs-placement="bottom" aria-label="Enable dark mode" data-bs-original-title="Enable dark mode">
                            <span class="nav-link-icon d-lg-inline-block">
                                <icon icon="theme-dark" height="1.25em" />
                            </span>
                            <span class="nav-link-title">Dark mode</span>
                        </a>
                    </li>

                </ul>
            </div>
        </div>
    </aside>

    <header class="navbar navbar-expand-md d-none d-lg-flex d-print-none">
        <div class="container-fluid">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu" aria-controls="navbar-menu" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="navbar-nav flex-row order-md-last">
                <div class="d-none d-md-flex">
                    <a v-show="theme && theme.theme == 'dark'" @click.prevent="setTheme('light')" class="nav-link px-0 cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="bottom" aria-label="Enable light mode" data-bs-original-title="Enable light mode">
                        <icon icon="theme-light" />
                    </a>
                    <a v-show="!(theme && theme.theme == 'dark')"  @click.prevent="setTheme('dark')" class="nav-link px-0 cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="bottom" aria-label="Enable dark mode" data-bs-original-title="Enable dark mode">
                        <icon icon="theme-dark" />
                    </a>
                </div>
                <div class="nav-item dropdown">
                    <a href="#" class="nav-link d-flex lh-1 text-reset p-0" data-bs-toggle="dropdown" aria-label="Open user menu">
                         <span class="avatar avatar-sm">
                            {{ userInitials }}
                        </span>
                        <div class="d-none d-xl-block ps-2">
                            <div>{{ creditMinutes }}</div>
                            <div class="mt-1 small text-secondary">minutes</div>
                        </div>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <router-link :to="{ 'name': 'profile' }" class="dropdown-item">
                            <span>{{userName}}</span>
                        </router-link>
                        <router-link :to="{ 'name': 'credits' }" class="dropdown-item">
                            <span>
                                <span class="nav-link-icon d-lg-inline-block">
                                    <icon icon="coin" height="1.25em" />
                                </span>
                                <span>
                                    {{ creditMinutes }}
                                    <span class="mt-1 small text-secondary">minutes</span>
                                </span>
                            </span>
                        </router-link>
                        <div class="dropdown-divider"></div>
                        <span>
                            <router-link v-for="(item, i) in userMenu" :key="i" class="dropdown-item" :class="{ 'active': item.route === $route.name }" :to="{ 'name': item.route }">
                                <span class="nav-link-icon d-lg-inline-block" v-show="item.icon">
                                    <icon :icon="item.icon" height="1.25em" />
                                </span>
                                <span class="nav-link-title">{{ item.title }}</span>
                            </router-link>
                        </span>
                    </div>
                </div>
            </div>
            <div class="collapse navbar-collapse" id="navbar-menu">
            </div>
        </div>
    </header>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState(["auth", "theme", "credit"]),

        userName() {
            if (!this.auth || !this.auth.user || !this.auth.user.name) {
                return "";
            }
            return this.auth.user.name;
        },
        creditMinutes() {
            return (Math.floor(this.credit.remaining) / 60).toFixed(2);
        },
        userInitials() {
            if (!this.auth || !this.auth.user || !this.auth.user.name) {
                return "";
            }
            const arr = Array.from(this.auth.user.name.toString());
            return arr[0].toLocaleUpperCase() + (arr.length > 1 ? arr[1].toLocaleUpperCase() : "");
        }
    },
    props: {
        menu: {
            type: Array,
            required: true
        },
        userMenu: {
            type: Array,
            required: false
        }
    },
    methods: {
        setTheme(theme) {
            this.$store.dispatch("theme/set", { theme });
        }
    }
};
</script>

<style lang="scss">
.navbar-brand-image {
    svg {
        height: 1.5em;
    }
}

.navbar-toggler-icon {
    width: 1em;
}
</style>
